export const PEER_RECLAIM_COLUMNS = [
    {
        Header: "Date",
        accessor: "awarded",
    },
    {
        Header: "Event",
        accessor: "event_name",
    },
    {
        Header: "Points",
        accessor: "amount",
    },
    {
        Header: "Reclaim?",
        accessor: "reclaim",
    },
    {
        Header: "Reason / Notes",
        accessor: "reason",
    },
];